function refreshCartUI() {
    const cart = window.PXUTheme && window.PXUTheme.jsAjaxCart;
    if (!cart) return;

    cart.updateView();
}
function showCardMessage(form, text) {
    const wrapper = form.closest('.product-image__wrapper');
    if (!wrapper) return;

    let box = wrapper.querySelector('.quick-add-message');
    if (!box) {
        box = document.createElement('div');
        box.className = 'quick-add-message';
        box.setAttribute('role', 'alert');
        wrapper.appendChild(box);
    }

    box.textContent = text;
    box.classList.add('is-visible');

    clearTimeout(box._hideTimer);
    box._hideTimer = setTimeout(function () {
        box.classList.remove('is-visible');
    }, 3000);
}
document.addEventListener('submit', async function (event) {
    const form = event.target.closest('.quick-add-form');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('.quick-add-button');
    if (button.disabled) return;
    button.disabled = true;
    button.classList.add('is-added');

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    let userMessage = "Sorry, we couldn't add that. Please try again.";

    try {
        const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new URLSearchParams(new FormData(form))
        });
        if (!response.ok) {
            try {
                const data = await response.json();
                if (data && data.description) {
                    userMessage = /in your cart/i.test(data.description)
                        ? 'Max quantity already in cart'
                        : data.description;
                }

            } catch (e) { }
            throw new Error('Add to cart failed');
        }
        const item = await response.json();
        refreshCartUI();
        document.dispatchEvent(new CustomEvent('quick-add:added'));
        QuickAdd.showAddedModal(item);
    } catch (error) {
        button.classList.remove('is-added');
        button.classList.add('is-error');
        showCardMessage(form, userMessage);
        console.error(error);
    } finally {
        setTimeout(function () {
            button.disabled = false;
            button.classList.remove('is-added', 'is-error');
        }, 3000);
    }
});
document.addEventListener('click', function (event) {
    const link = event.target.closest('a.quick-add-button');
    if (!link) return;

    const card = link.closest('.product__thumbnail');
    const themeButton = card && card.querySelector('.js-quick-shop-link');
    if (!themeButton) return;

    event.preventDefault();
    themeButton.click();
});

(function () {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function escapeHTML(value) {
        const div = document.createElement('div');
        div.textContent = value == null ? '' : value;
        return div.innerHTML;
    }

    function money(cents) {
        return Shopify.formatMoney(cents);
    }



    function buildConfirmationHTML(item, cart) {
        const qty = item.quantity || 1;
        const onSale = item.original_price > item.final_price;
        const cartUrl = (window.PXUTheme && PXUTheme.routes && PXUTheme.routes.cart_url) || '/cart';
        const itemsWord = function (n) { return n === 1 ? ' Item' : ' Items'; };
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

        let imageHTML = '';
        const imageUrl = item.featured_image && item.featured_image.url;
        if (imageUrl) {
            const sized = imageUrl + (imageUrl.indexOf('?') > -1 ? '&' : '?') + 'width=900';
            const ratio = item.featured_image.aspect_ratio || 1;
            imageHTML = '<div class="image__container quick-add-confirm__image" style="aspect-ratio: ' + ratio + ';">' +
                '<img src="' + sized + '" alt="' + escapeHTML(item.product_title) + '">' +
                '</div>';

        }

        return '' +
            '<div class="product_section container is-justify-space-between has-padding-bottom quickshop quick-add-confirm">' +
            '<div class="product__images one-half column medium-down--one-whole">' + imageHTML + '</div>' +
            '<div class="product__information one-half column medium-down--one-whole">' +
            '<div class="product-block product-block--title product-block--first">' +
            '<h1 class="product-title title">' + qty + itemsWord(qty) + ' Added To Cart</h1>' +
            '</div>' +
            '<div class="product-block">' +
            '<p class="quick-add-confirm__name"><a href="' + (item.url || '#') + '">' + escapeHTML(item.product_title) + '</a></p>' +
            (variant ? '<p class="quick-add-confirm__variant">' + escapeHTML(variant) + '</p>' : '') +
            '</div>' +
            '<div class="product-block product-block--price">' +
            '<div class="modal_price subtitle"><div class="price-ui">' +
            '<span class="price' + (onSale ? ' sale' : '') + '"><span class="money">' + money(item.final_price) + '</span></span>' +
            (onSale ? ' <span class="compare-at-price"><span class="money">' + money(item.original_price) + '</span></span>' : '') +
            '</div></div>' +
            '</div>' +
            '<div class="product-block">' +
            '<div class="quick-add-confirm__subtotal">' +
            '<span>Cart Subtotal (' + cart.item_count + itemsWord(cart.item_count) + ')</span>' +
            '<span class="money">' + money(cart.total_price) + '</span>' +
            '</div>' +
            '</div>' +
            '<div class="product-block product-block--form">' +
            '<button type="button" class="button action_button action_button--secondary quick-add-confirm__btn" data-quick-add-close>Continue Shopping</button>' +
            '<a href="' + cartUrl + '" class="button action_button button--secondary quick-add-confirm__btn">View Cart</a>' +
            '</div>' +
            '</div>' +
            '</div>';
    }

    function showAddedModal(item) {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (response) { return response.json(); })
            .then(function (cart) {
                const $container = $('.js-quick-shop');
                $container.html(buildConfirmationHTML(item, cart));

                if ($('.fancybox-active').length) {
                    // Swapping inside an open lightbox: html() removed Fancybox's close button, so put one back
                    $container.append('<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="Close"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg></button>');
                } else {
                    $.fancybox.open($container, {
                        baseClass: 'quick-shop__lightbox quick-add-confirm__lightbox',
                        hash: false,
                        infobar: false,
                        toolbar: false,
                        smallBtn: true,
                        touch: false
                    });
                }
                $('.fancybox-container').addClass('quick-add-confirm__lightbox');
            })
            .catch(function (error) { console.error(error); });
    }

    window.QuickAdd = { showAddedModal: showAddedModal };

    document.addEventListener('click', function (event) {
        if (event.target.closest('[data-quick-add-close]')) {
            $.fancybox.close();
        }
    });
})();
window.addEventListener('load', function () {
    if (!window.jQuery) return;

    jQuery(document).ajaxSuccess(function (event, xhr, settings) {
        // Only react to cart adds
        if (!settings.url || settings.url.indexOf('/cart/add.js') === -1) return;
        // Only when a lightbox is open, meaning the add came from the quick shop modal
        if (!jQuery('.fancybox-active').length) return;

        let item = xhr.responseJSON;
        if (!item) {
            try { item = JSON.parse(xhr.responseText); } catch (e) { return; }
        }
        if (item && item.product_title) {
            QuickAdd.showAddedModal(item);
        }
    });
});